import { useRecordCategoriesQuery } from './index';

const recordCategoryIdByDescription = (description) => {
    const { data: recordCategories = [] } = useRecordCategoriesQuery({});
    const recordCategory = recordCategories?.find((recordCategory) => recordCategory.short_description === description);
    return recordCategory?.id || null;
};

export default {
    recordCategoryIdByDescription,
};
